import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { connect } from 'react-redux';
import * as homeActions from '../home/redux/actions';
import * as appSettingsActions from '../app-setting/redux/actions';
import * as actions from './redux/actions';
import { drapcodeIcon } from '../../common/custom/icon-library';
import TooltipInfo from '../../common/docs/TooltipInfo';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { PromptDataDisplay } from './PromptDataDisplay';
import CustomSelect from '../home/collections/CustomSelect';
import { BASE_AI_MODELS } from '../../common/utils/prompt-constants';
import CustomInputWithIconNoFormGroup from '../../common/ui/CustomInputWithIconNoFormGroup';

export class CollectionWithPrompt extends Component {
  static propTypes = {
    collections: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    homeActions: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    projectId: PropTypes.string,
    version: PropTypes.string,
  };

  state = {
    creationFailedMsg: '',
    promptFields: [],
    isOpenCollectionCreate: false,
    promptJsonConfig: {},
    promptName: '',
    selectedAIModel: null,
    extractedFields: [],
  };

  handlePromptInputSubmit = async (values) => {
    if (!values.promptText || !values.aiModel) {
      this.setState({
        creationFailedMsg: 'Prompt text and AI Model are required fields.',
      });
      return;
    }

    const { projectId, actions, version, appSetting } = this.props;
    const { projectDetail } = appSetting || {};
    const selectedModelType = this.state.selectedAIModel || values.aiModel.value || 'OPEN_AI';
    const aiModelConfig =
      (projectDetail &&
        projectDetail.aiModelConfigs.find((cfg) => cfg.modelType === selectedModelType)) ||
      {};
    const apiKey = aiModelConfig.setting ? aiModelConfig.setting.secretKey : '';
    const modelEngine = aiModelConfig.modelType || selectedModelType;

    const data = {
      userPrompt: values.promptText,
      generatedCodeConfig: 'create_collection',
      codeGenerationModel: '',
      apiKey,
      aiModel: modelEngine,
      projectId,
      version,
    };

    try {
      const extractedFields = await actions.extractFieldsFromPrompt(data);
      if (extractedFields && extractedFields.data.fields) {
        let formattedFieldTitles = extractedFields.data.fields.flat().map((field) => ({
          title: (field.fieldTitle && field.fieldTitle.en) || 'Untitled',
          type: field.type || 'text',
        }));
        this.setState({
          promptFields: formattedFieldTitles,
          isOpenCollectionCreate: true,
          promptName: values.promptText,
          selectedAIModel: selectedModelType,
          creationFailedMsg: '',
          extractedFields: extractedFields.data.fields,
        });
      } else {
        console.error(
          "Extracted fields do not contain a valid 'fields' property:",
          extractedFields,
        );
        this.setState({
          creationFailedMsg: "Invalid response from extraction. 'fields' property missing.",
        });
      }
    } catch (error) {
      console.error('Error extracting fields:', error);
      this.setState({ creationFailedMsg: 'Failed to extract fields. Please try again.' });
    }
  };

  handleFinalPromptSubmit = async (jsonConfig) => {
    const { projectId, version, actions, history, home, homeActions, projectOnBoardActions } =
      this.props;
    const data = { ...jsonConfig, projectId, version };
    const createCollectionResponse = await actions.createCollectionWithPrompt(data);
    await actions.loadProjectCollections({ projectId, version });

    if (
      createCollectionResponse &&
      createCollectionResponse.data &&
      createCollectionResponse.data.uuid
    ) {
      const collectionId = createCollectionResponse.data.uuid;
      homeActions.loadEditorCollections({ projectId, version });
      actions.loadProjectCollectionDetail({ projectId, collectionId, version });
      if (home && home.collections.length === 0) {
        projectOnBoardActions.changeProjectStatus({
          state: 'COLLECTION_CREATED',
          status: 'COMPLETE',
          projectId,
          version,
        });
      }
      const redirectPath = `/collections/${version}/v/${projectId}/edit/${collectionId}`;
      history.push(redirectPath);
      this.setState({ isOpenCollectionCreate: false });
      return;
    }

    console.error('Failed to retrieve collectionId from response:', createCollectionResponse);
  };

  componentDidMount() {
    const {
      appSettingsActions: { loadProjectDetailAppSetting },
      projectId,
      version,
    } = this.props;
    loadProjectDetailAppSetting({ projectId, version });
  }

  render() {
    const { creationFailedMsg, isOpenCollectionCreate, promptFields } = this.state;
    const { appSetting, collections } = this.props;
    const { projectDetail } = appSetting || {};
    if (!projectDetail) return '';
    const extractFieldsFromPromptPending = collections.extractFieldsFromPromptPending;
    let hasEnabledAIModelConfigs = false;
    let modelOptions = [];
    let defaultAIModelValue = null;
    if (appSetting && appSetting.projectDetail) {
      const { projectDetail } = appSetting;
      const { aiModelConfigs } = projectDetail;
    if (aiModelConfigs && aiModelConfigs.length > 0) {
      const enabledConfigs = aiModelConfigs.filter((cfg) => cfg.isEnabled );
      if (enabledConfigs.length > 0) {
        hasEnabledAIModelConfigs = true;
        const defaultConfig = enabledConfigs.find((cfg) => cfg.isDefault);
        if (defaultConfig) {
          const base = BASE_AI_MODELS.find((opt) => opt.value === defaultConfig.modelType);
          defaultAIModelValue = {
            label: base.label || defaultConfig.modelType,
            value: defaultConfig.modelType,
          };
        }
          modelOptions = enabledConfigs.map((cfg) => {
            const base = BASE_AI_MODELS.find((opt) => opt.value === cfg.modelType);
            return {
              label: base.label || cfg.modelType,
              value: cfg.modelType,
            };
          });
      }
    }
  }
    // Rest of render logic continues...

    return (
      <div className="card">
        <div className="card-header card-header-icon" data-background-color="drapcode-dark-blue">
          <i className={`wb ${drapcodeIcon('collection')}`}></i>
        </div>
        <div className="card-content">
          <div className="card-title-header">
            <h4 className="card-title">
              Create Collection <span style={{ textTransform: 'none' }}>via</span> Prompt
            </h4>
            <div className="card-cta"></div>
          </div>
          <Formik
            enableReinitialize
            initialValues={{
              promptText: '',
              aiModel: defaultAIModelValue,
            }}
            onSubmit={this.handlePromptInputSubmit}
          >
            {({ values, setFieldValue, isSubmitting }) => (
              <Form className="form-horizontal">
                <div className="row mx-auto">
                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 mb-4">
                    <CustomInputWithIconNoFormGroup
                      icon="text"
                      title="Prompt Text"
                      style=""
                      required={true}
                    >
                      <Field
                        type="text"
                        name="promptText"
                        className="form-control form-control-sm"
                        placeholder="Enter prompt text"
                      />
                      <TooltipInfo
                        title="Enter Collection Name of your choice. It should not contain special characters or numbers."
                        headerText="Collection Name"
                        showHeader={true}
                        showArrow={true}
                        append={true}
                      />
                    </CustomInputWithIconNoFormGroup>
                    <p className="text-danger">
                      <ErrorMessage name="promptText" />
                    </p>

                    <div className="form-group">
                      <label className="mb-0">Select AI Model</label>
                      <CustomInputWithIconNoFormGroup
                        icon="dropdown"
                        title="Select AI Model"
                        required
                      >
                        <CustomSelect
                          name="aiModel"
                          isMulti={false}
                          options={modelOptions}
                          value={values.aiModel}
                          onChange={(name, value) => {
                            setFieldValue('aiModel', value);
                            this.setState({ selectedAIModel: value.value });
                          }}
                        />
                        <p className="text-danger">
                          <ErrorMessage name="aiModel" />
                        </p>
                      </CustomInputWithIconNoFormGroup>
                      {extractFieldsFromPromptPending && (
                        <div className="text-dark mt-2 ml-6">Extracting fields, please wait...</div>
                      )}
                      {creationFailedMsg && <div className="text-danger">{creationFailedMsg}</div>}
                    </div>
                  </div>

                  <div className="col-md-12 col-lg-12 text-right">
                    <button
                      className="btn btn-theme-submit btn-md"
                      type="submit"
                      disabled={
                        !hasEnabledAIModelConfigs || isSubmitting || extractFieldsFromPromptPending
                      }
                    >
                      <i className="wb webconnect-plus"></i> Create
                    </button>
                    {!hasEnabledAIModelConfigs && (
                      <div className="text-danger mt-2 ml-6">
                        Please configure the AI model in the AI Model Configuration section.
                      </div>
                    )}
                  </div>
                </div>
              </Form>
            )}
          </Formik>
          {isOpenCollectionCreate && (
            <Modal
              isOpen={isOpenCollectionCreate}
              toggle={() => this.setState({ isOpenCollectionCreate: false })}
              backdrop="static"
              className="modal-md mt-5 mx-auto"
            >
              <ModalHeader
                toggle={() => this.setState({ isOpenCollectionCreate: false })}
                className="border-bottom"
              >
                <strong>Create Collection via Prompt</strong>
              </ModalHeader>
              <ModalBody>
                <PromptDataDisplay
                  extractedFields={this.state.extractedFields}
                  promptFields={promptFields}
                  promptName={this.state.promptName}
                  selectedAIModel={this.state.selectedAIModel}
                  onUpdateJsonConfig={(config) => this.setState({ promptJsonConfig: config })}
                  onSubmit={this.handleFinalPromptSubmit}
                  onCancel={() => this.setState({ isOpenCollectionCreate: false })}
                />
              </ModalBody>
            </Modal>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    collections: state.collections,
    home: state.home,
    appSetting: state.appSetting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    homeActions: bindActionCreators({ ...homeActions }, dispatch),
    appSettingsActions: bindActionCreators({ ...appSettingsActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CollectionWithPrompt);
